module.exports = __webpack_public_path__ + "static/media/text-bold.48594d34.svg";